export default __webpack_public_path__ + "static/media/open_in_full_black_24dp.a0db7abc.svg";